import { defineMessages } from 'react-intl'

const scope = `procurify.components.DataTable.APItemMatchedPOItemCell`

export default defineMessages({
  purchasedOrderLabel: {
    id: `${scope}.purchasedOrderLabel`,
    defaultMessage: 'PO',
  },
  purchaseOrderLabelAriaLabel: {
    id: `${scope}.purchaseOrderLabelAriaLabel`,
    defaultMessage: 'Purchase Order Link',
  },
  detailsButtonText: {
    id: `${scope}.detailsButtonText`,
    defaultMessage: 'Details',
  },
})
